module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-19 at 4.38.03 PM.1392a9e1.jpeg";